import { DOMHelper } from "./helpers/dom-helper";
import { EventType } from "./constants/event-type-constants";
import { ObjectConstants, Selector } from "./constants/closing-without-lp";


export class ClosingWithoutLp {
  isMobile: boolean;
  accordionList: Array<Element> = [];

  constructor(isMobile: boolean) {
    this.isMobile = isMobile;
  }

  init() {
    this.prepareAccordionHeaders(Selector.accordionHeader);
    this.toggleAccordionEvents(Selector.accordionArrow);
  }

  prepareAccordionHeaders(selector: string) {
    this.accordionList = DOMHelper.querySelectorAsArray(selector);
  }

  toggleAccordionEvents(arrowSelector: string) {
    this.accordionList.forEach((header) => {
      header.addEventListener(EventType.CLICK, () => {
        this.toggleAccordion(header, arrowSelector);
      });
    });
  }

  toggleAccordion(header: Element, arrowSelector: string) {
    const accordionContent = header.nextElementSibling;
    accordionContent?.classList.toggle(ObjectConstants.active);
    header.querySelector(arrowSelector)?.classList.toggle(ObjectConstants.active);
  }
}
